export enum RequestExcusableType {
  Normal = 0,
  NFF = 1,
  CID = 2,
}
